import React from "react";
// import { useState } from "react";
import EvaluationPttScreen from './EvaluationPttScreen';
// import { userStorage } from "src/common/Storage";

const EvaluationSelfByPttScreen = () => {
  // var userInfo = useState(userStorage.getUser() || {});
  // return <EvaluationPttScreen userInfo={userInfo}/>
  return <EvaluationPttScreen/>
} 

export default EvaluationSelfByPttScreen;
